import { render, staticRenderFns } from "./PosCashReceipt.vue?vue&type=template&id=e6a52498&scoped=true"
import script from "./PosCashReceipt.vue?vue&type=script&lang=js"
export * from "./PosCashReceipt.vue?vue&type=script&lang=js"
import style0 from "./PosCashReceipt.vue?vue&type=style&index=0&id=e6a52498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a52498",
  null
  
)

export default component.exports